import { listingsPageBlocks } from '~/common/const';
import { getCategories } from '~/api/catalogCategory';
import type {
  DynamicPageContext,
  MinimalOfferItem,
  OfferFilter,
  ResponseCatalogOffers,
} from '~/interfaces/api';
import type { GetCategoryRatings, ListingsGetCategory } from '~/interfaces/app';
import initRequestBody from '~/components/distributor/initRequestBody';
import {
  getAnyPostData,
  getAnyPostDataDebug,
  getCategoryData,
} from '~/api/pageCategoryList';
import { _getPromocodes, _getShopInfo } from '~/api/shopOffers';
import { useGlobalStore } from '~/stores/global';

export async function initListingsData(
  type: 1 | 2 | 3,
  context: DynamicPageContext,
  query,
  discount = false,
  isPageSpeedBot = false,
  store
) {
  const globalStore = useGlobalStore();
  const reqBody = initRequestBody(query);
  if (discount) reqBody.discount = 1;
  let params: {
    [key: string]:
      | string
      | (string | null)[]
      | number
      | boolean
      | undefined
      | null;
  } = {
    region_id: store.region.id,
    sem: store.sem || undefined,
    device: store.device || undefined,
    split: store.split,
    adult: store.adult,
    all: store.debugPanelAll || undefined,
  };
  let urlFilters: string;
  let urlProducts: string;
  let getCategory;
  let getShopInfo = new Promise((resolve) => {
    resolve({});
  });
  let getPromocodes = new Promise((resolve) => {
    resolve({});
  });
  let getRatings: Promise<GetCategoryRatings> | null = new Promise(
    (resolve) => {
      resolve({});
    }
  );
  const getBetween = (w: number, min: number, max: number) => {
    return w >= min && w <= max;
  };
  // формируем данные в зависимости от переданного типа
  switch (type) {
    case 1: // запрос для брендов
      urlFilters = `/brands/${context.brand_id}/filters`;
      urlProducts = `/brands/${context.brand_id}/list`;
      // eslint-disable-next-line no-case-declarations
      const brandsData = await getCategoryData<ListingsGetCategory>(
        `/brands/${context.brand_id}/categories`,
        {
          params: { region_id: store.region.id },
        }
      ).catch(() => {});
      if (brandsData && !brandsData?.cancelToken) {
        getCategory = { categories: brandsData } || { categories: [] };
      } else getCategory = { categories: [], cancelToken: true };
      break;
    case 2: // запрос для магазина
      urlFilters = `/shops/${context.shop_id}/filters`;
      urlProducts = `/shops/${context.shop_id}/offers`;
      params = { ...params, category_id: query?.category_id };
      // eslint-disable-next-line no-case-declarations
      const shopsData = await getCategoryData<ListingsGetCategory>(
        `/shops/${context.shop_id}/categories`,
        {
          params: { region_id: store.region.id, adult: store.adult },
        }
      ).catch(() => {});
      if (shopsData && !shopsData?.cancelToken) {
        getCategory = {
          // @ts-ignore
          categories: shopsData,
          selected: query.category_id
            ? { id: Number(query.category_id), adult: false }
            : undefined,
        };
      } else {
        // @ts-ignore
        getCategory = { categories: [], cancelToken: true };
      }
      getShopInfo = await _getShopInfo(context.shop_id || 0);
      getPromocodes = await _getPromocodes(context);

      break;
    case 3: // запрос для категорий
      urlFilters = `/categories/${context.category_id}/filters`;
      urlProducts = `/categories/${context.category_id}/list`;

      params = {
        ...params,
        brand_id: context?.brand_id,
        preset_id: context?.preset_id,
        // @ts-ignore
        shop_ids: query?.shop_ids,
      };
      // console.time('categoriesData');
      // eslint-disable-next-line no-case-declarations
      const categoriesData = await getCategories(`${context.category_id}`, {
        params: { region_id: store.region.id },
      });
      if (categoriesData && categoriesData?.cancelToken)
        return { categories: [], cancelToken: true };
      getCategory = categoriesData
        ? {
            // @ts-ignore
            categories: [],
            selected: categoriesData,
          }
        : { categories: [] };

      if (store.isBot) {
        getRatings = await getAnyPostData(
          `/categories/${context.category_id}/ratings`,
          reqBody,
          {
            params: {
              ...params,
              sort: query?.['products-sort'] || 'popularity',
            },
          }
        );
      } else {
        getRatings = null;
      }
      break;
  }
  // формируем параметры запроса
  const paramsP = {
    ...params,
    sort: query?.['products-sort'] || 'popularity',
    page: store.isBot
      ? Number(query.page) || 1
      : ((Number(query.page) || 1) - 1) * listingsPageBlocks + 1,
    per_page: store.isBot
      ? globalStore.perPageListingValue * listingsPageBlocks
      : globalStore.perPageListingValue,
  };

  // async function getOffersListModels(productsId: ResponseModelOffers[]) {
  //   const ids = productsId.map((item) => item?.id);
  //   const data = {
  //     models_ids: ids,
  //     price_filter: {
  //       min: 0,
  //       max: 0,
  //     },
  //   };
  //   const res = await getOffersForModelsList(data, {
  //     region_id: store.region.id,
  //     page: 1,
  //     per_page: 5,
  //     sem: store.sem || undefined,
  //     device: store.device || undefined,
  //     all: store?.debugPanelAll || undefined,
  //   });
  //   if (res?.cancelToken) return [];
  //   if (res?.length > 0) {
  //     return productsId.map((productsItem: ResponseModelOffers) => {
  //       if (productsItem?.type === 'offer') {
  //         return productsItem;
  //       }
  //       res.find((resOfferItem: ModelOfferItem) => {
  //         if (resOfferItem?.model_id === productsItem?.id) {
  //           productsItem.offers = resOfferItem?.offers;
  //           return true;
  //         }
  //         return false;
  //       });
  //       return productsItem;
  //     });
  //   }
  // }

  // async function getOffersForProducts(products: ResponseModelOffers[]) {
  //   const promises = products.map(async (item: ResponseModelOffers, index) => {
  //     // что бы запрашивались офферы только для первых 50 офферов, а не для всех index > 49
  //     if (item.type === 'offer' || index > 49) {
  //       return item;
  //     }
  //     // @ts-ignore
  //     const res = await getModelsOffersList(item.id, null, {
  //       region_id: store.region.id,
  //       page: 1,
  //       per_page: 5,
  //       sem: store.sem || undefined,
  //       device: store.device || undefined,
  //       split: store.split,
  //       all: store.debugPanelAll || undefined,
  //     });
  //     if (res?.list && item) {
  //       item.offers = res?.list || [];
  //     }
  //     return item;
  //   });
  //   return await Promise.all(promises);
  // }

  // задаем промис для продукта
  async function productsPromise() {
    const productsData =
      type === 3
        ? await getAnyPostDataDebug<ResponseCatalogOffers>(
            urlProducts,
            reqBody,
            {
              params: paramsP,
            },
            true
          )
        : await getAnyPostData<ResponseCatalogOffers>(
            urlProducts,
            reqBody,
            {
              params: paramsP,
            },
            true
          );
    if (productsData) {
      if (store.isBot && productsData && productsData.list) {
        // если запрос от поискового бота
        productsData.list = productsData.list.map((item: MinimalOfferItem) => {
          if (item.type === 'offer' && !item.model_id) {
            item.description = '';
          }
          return item;
        });
        // await getOffersForProducts(productsData.list);
        // вызов упрощенной функции для ботов
        // await getOffersListModels(productsData.list);
      }
      if (isPageSpeedBot) {
        return {
          ...productsData,
          list: productsData.list.slice(0, 4),
        };
      }
      return productsData;
    }
  }

  // задаем промис для фильтров
  async function filtersPromise() {
    if (isPageSpeedBot) return null;
    const filtersData = await getAnyPostData(
      urlFilters,
      null,
      { params },
      true
    );
    // Добавляем статус актив для всех фильтов и для реализации логики визуализации с учетом контекста
    if (type === 3 && filtersData) {
      const addActive = (filtersArr) => {
        if (filtersArr?.length === 0 || typeof filtersArr === 'undefined')
          return;
        return filtersArr.map((item) => ({ ...item, active: true }));
      };
      if ('brands' in filtersData) {
        filtersData.brands = addActive(filtersData.brands);
      }
      if ('shops' in filtersData) {
        filtersData.shops = addActive(filtersData.shops);
      }
      if ('filters' in filtersData) {
        filtersData.filters = filtersData.filters.map((item: OfferFilter) => {
          if (item.type === 'RANGE' || item.type === 'BOOL')
            return { ...item, active: true };
          if (item?.allowed_values)
            return {
              ...item,
              allowed_values: addActive(item.allowed_values),
            };
          return item;
        });
      }
    }

    if (filtersData) {
      if (store.isBot) {
        // если запрос от поискового бота
        const filt = filtersData ? { ...filtersData } : null;
        if (filt && filt.filters) {
          filt.filters = filt.filters.reduce(
            (acc: OfferFilter[], el: OfferFilter) => {
              if (el.type === 'ENUM') {
                return [
                  ...acc,
                  {
                    ...el,
                    allowed_values:
                      'allowed_values' in el
                        ? el?.allowed_values?.slice(0, 10)
                        : [],
                    description: '',
                  },
                ];
              }
              return [...acc, { ...el, description: '' }];
            },
            []
          );
        }
        return filt && filt.filters ? filt : { ...filt, filters: [], count: 0 };
      }
      // @ts-ignore
      return filtersData ? { filters: [], ...filtersData } : null;
    } else {
      return { filters: [], count: 0 };
    }
  }

  // запрашиваем промисы и формируем продукты и фильтры
  const [products, filters, catData, ratings, shopinfo, promocodes] =
    await Promise.all([
      productsPromise(),
      filtersPromise(),
      getCategory,
      getRatings,
      getShopInfo,
      getPromocodes,
    ]);
  const updateSeoTextsData = {
    shop_count: products?.shop_count || 0,
    price_min: products?.price_min || 0,
    price_max: products?.price_max || 0,
    offer_count: products?.offer_count || 0,
  };
  store.updateSeoTexts(updateSeoTextsData);

  const navSections = <string[]>[
    ['base', undefined],
    // раскомментарить, когда будут данные по выборкам товаров из API:
    // ['shopoffers', products?.total || undefined],
    ['promocodes', promocodes?.length || false],
    ['shopinfo', products?.total || true],
  ].reduce((sum, el) => (el[1] ? [...sum, el[0]] : sum), []);
  const getInitCategories = () => {
    if (type === 3) {
      return (products && products?.categories) || [];
    }
    return catData?.categories || [];
  };
  if (products?.discount_max) {
    const maxDiscount = products?.discount_max;
    if (getBetween(maxDiscount, 10, 29)) products.discount_max = 10;
    if (getBetween(maxDiscount, 30, 49)) products.discount_max = 30;
    if (getBetween(maxDiscount, 50, 100)) products.discount_max = 50;
  }
  return {
    products: (products && products?.list) || null,
    filters,
    ratings,
    categories: getInitCategories(),
    selectedCategory: catData?.selected,
    total: products?.total || 0,
    active: 'base',
    discount_max: products?.discount_max || 1,
    shop_rating_high_count: products?.shop_rating_high_count,
    visit_count: products?.visit_count,
    promocodes,
    updateSeoTextsData,
    shopOffers: {
      navSections,
      shopinfo,
    },
  };
}
